export const DEFAULT_VALUES: DefaultValues = {
    confidenceLevel: 95,
    distributionFunction: 'AUTOMATIC',
    goal: 'HIGHEST_RESULT',
    targetMarginOfError: 5,
};

// Canonical URL for The Real Startup Book online, shared across the games-and-tools
// rollout so sibling repos (plinkromatic, startup-poker, food-truck) can mirror the
// same value. Update here when the 2nd-edition landing page becomes distinct.
export const RSB_ONLINE_URL = 'https://realstartupbook.com/';

export const DISTRIBUTION_FUNCTIONS: Record<string, string> = {
    AUTOMATIC: 'Automatic',
    NORMAL: 'Z-test',
    T: 'T-test',
};

export const FIELD_MAPPING: Record<string, string> = {
    confidenceLevel: 'cl',
    distributionFunction: 'df',
    goal: 'g',
    name: 'n',
    populationSize: 'ps',
    resultMaxValue: 'rxv',
    resultMinValue: 'rnv',
    targetMarginOfError: 'tme',
    threshold: 'th',
};

export const GOALS: Record<string, string> = {
    LOWEST_RESULT: 'Lowest results',
    HIGHEST_RESULT: 'Highest results',
};
